// extracted by mini-css-extract-plugin
export default {"link":"icon-link_link__GzZxv"};